import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { PageFooter } from "@components/page-footer";
import { HeadeSearch } from "@components/head-search";
import { Countdown } from "@components/countdown";
import { PageTop } from "@components/page-top";
import { Account, AccountStorage } from "@services/account";
var account = new Account();
var accountStorage = new AccountStorage();
export default {
  components: {
    HeadeSearch: HeadeSearch,
    PageFooter: PageFooter,
    Countdown: Countdown,
    PageTop: PageTop
  },
  data: function data() {
    return {
      id: "",
      type: "order",
      isLogin: false,
      orderDetail: {},
      serialNumber: "",
      createQrCodeUrlPrefix: "/pjyy-deepexi-aggregation/api/v1/qrcode/getQrCode",
      bill: {
        data: {}
      },
      order: {
        data: {}
      },
      payment: {
        list: [],
        mode: "WXPAY"
      },
      countDown: {
        show: false,
        value: 0
      },
      qrCodeModal: {
        show: false,
        overtime: 60,
        regetShow: false,
        qrCodeUrl: ""
      },
      payUrl: ""
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var query, params, id, type;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            query = _this.$route.query;
            params = _this.$route.params;
            id = params.orderId;
            type = query.type;
            _this.isLogin = account.isLogined();
            _this.id = id;
            type && (_this.type = type);
            _context.next = 9;
            return _this.initPayMode();
          case 9:
            if (!(type === "bill")) {
              _context.next = 14;
              break;
            }
            _context.next = 12;
            return _this.initBillDetailData();
          case 12:
            _context.next = 17;
            break;
          case 14:
            _context.next = 16;
            return _this.initOrderDetailData();
          case 16:
            _this.startCheckOrderPayStatus();
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopCheckOrderPayStatus();
    this.clearRegetQrCodeTimeout();
  },
  methods: {
    clearRegetQrCodeTimeout: function clearRegetQrCodeTimeout() {
      clearTimeout(this.regetQrCodeTimer);
    },
    createRegetQrCodeTimeout: function createRegetQrCodeTimeout() {
      var _this2 = this;
      this.clearRegetQrCodeTimeout();
      if (this.qrCodeModal.overtime > 0) {
        this.regetQrCodeTimer = setTimeout(function () {
          _this2.clearRegetQrCodeTimeout();
          _this2.qrCodeModal.overtime -= 1;
          _this2.createRegetQrCodeTimeout();
        }, 1000);
      } else {
        this.qrCodeModal.regetShow = true;
      }
    },
    // 跳转到账单列表页
    goToBillListPage: function goToBillListPage() {
      this.$router.replace({
        name: "billList",
        params: {
          status: "0"
        }
      });
    },
    // 跳转到订单列表页
    goToOrderListPage: function goToOrderListPage() {
      this.$router.replace({
        name: "order",
        params: {
          status: "0"
        }
      });
    },
    // 跳转到支付成功页
    goToPaymentSuccessPage: function goToPaymentSuccessPage() {
      this.$router.replace({
        name: "payResult",
        params: {
          payType: "SUCCESS",
          orderId: this.id
        }
      });
    },
    // 关闭支付弹框
    closePayModal: function closePayModal() {
      this.clearRegetQrCodeTimeout();
      this.qrCodeModal.show = false;
    },
    // 停止检查订单支付状态
    stopCheckOrderPayStatus: function stopCheckOrderPayStatus() {
      clearInterval(this.order.payStatusInterval);
    },
    // 开始检查订单支付状态
    startCheckOrderPayStatus: function startCheckOrderPayStatus() {
      var _this3 = this;
      this.order.payStatusInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.pullPaymentStatus();
            case 2:
              result = _context2.sent;
              if (result.data.code == "200") {
                // const payStatus = result.data.data;
                // if (payStatus) {
                _this3.stopCheckOrderPayStatus();
                _this3.clearRegetQrCodeTimeout();
                _this3.goToPaymentSuccessPage();
                // }
              } else if (result.data.code == "309") {} else {
                _this3.stopCheckOrderPayStatus();
                _this3.clearRegetQrCodeTimeout();
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })), 2000);
    },
    // 停止检查账单支付状态
    stopCheckBillPayStatus: function stopCheckBillPayStatus() {
      clearInterval(this.bill.payStatusInterval);
    },
    // 开始检查账单支付状态
    startCheckBillPayStatus: function startCheckBillPayStatus() {
      var _this4 = this;
      this.bill.payStatusInterval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result, payStatus;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.pullPaymentStatus();
            case 2:
              result = _context3.sent;
              if (result.data.code === "200") {
                payStatus = result.data.data;
                if (payStatus) {
                  _this4.stopCheckBillPayStatus();
                  _this4.clearRegetQrCodeTimeout();
                  _this4.goToPaymentSuccessPage();
                }
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })), 2000);
    },
    // 拉取订单/账单支付状态
    pullPaymentStatus: function pullPaymentStatus() {
      return this.$getHttpClient({
        useSpinner: false,
        useResponseToast: false
      }).get("/pjyy-deepexi-pay-center/rpc/v2/openPay/pcQueryOrderPayStatus?orderNo=" + this.id);
    },
    // 倒计时停止跳转到订单列表
    countDownStopHandler: function countDownStopHandler() {
      this.stopCheckOrderPayStatus();
      this.clearRegetQrCodeTimeout();
      this.goToOrderListPage();
    },
    // 拉取订单详情
    pullOrderDetailData: function pullOrderDetailData() {
      return this.$getHttpClient().get("/pjyy-deepexi-order-center/api/v1/order/OcOrderLine/orderLineList", {
        params: {
          orderNumber: this.id
        }
      }).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        }
        return;
      });
    },
    // 初始化订单详情信息
    initOrderDetailData: function initOrderDetailData() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.pullOrderDetailData();
            case 2:
              result = _context4.sent;
              if (result) {
                _this5.order.data = result;
                _this5.countDown.value = Math.floor(result.closeTime / 1000) + 1;
                _this5.countDown.show = true;
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 拉取账单详情
    pullBillDetailData: function pullBillDetailData() {
      return this.$getHttpClient().post("/pjyy-deepexi-order-center/api/v1/bill/viewBill", {
        documentNo: this.id
      }).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        }
        return;
      });
    },
    // 初始化账单详情信息
    initBillDetailData: function initBillDetailData() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var result;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.pullBillDetailData();
            case 2:
              result = _context5.sent;
              if (result) {
                _this6.bill.data = result;
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    // 拉取订单支付二维码信息
    pullOrderQrCodeData: function pullOrderQrCodeData() {
      var _this7 = this;
      var useSpinner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var data = {
        orderSource: 5,
        orderOrErpId: this.id,
        orderType: 2,
        environment: 2,
        titleName: "普健医药商城"
      };
      return this.$getHttpClient({
        useSpinner: useSpinner,
        useResponseToast: false
      }).post("/pjyy-deepexi-pay-center/rpc/v2/pcShopPay/pcShopPay", data).then(function (responses) {
        var data = responses.data;
        if (data.code == "200") {
          return data.data;
        } else {
          _this7.$toast.mount(_this7.$toast.create(data.msg, {
            unmounted: function unmounted() {
              _this7.goToBillListPage();
            }
          }));
        }
        return;
      });
    },
    // 拉取账单支付二维码信息
    pullBillQrCodeData: function pullBillQrCodeData() {
      var _this8 = this;
      var useSpinner = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var loginCompanyId = accountStorage.getCacheUserInfo().loginCompanyId;
      var data = {
        companyId: loginCompanyId,
        documentNo: this.id,
        payChannel: this.payment.mode,
        payType: "NATIVE",
        titleName: "普健医药商城"
      };
      return this.$getHttpClient({
        useSpinner: useSpinner,
        useResponseToast: false
      }).post("/pjyy-deepexi-pay-center/api/v1/bill/pay", data).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        } else {
          _this8.$toast.mount(_this8.$toast.create(data.msg, {
            unmounted: function unmounted() {
              _this8.goToOrderListPage();
            }
          }));
        }
        return;
      });
    },
    // 初始化支付二维码信息
    initQrCodeInfo: function initQrCodeInfo() {
      var _arguments = arguments,
        _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var useSpinner, result;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              useSpinner = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;
              result = {};
              if (!(_this9.type === "bill")) {
                _context6.next = 8;
                break;
              }
              _context6.next = 5;
              return _this9.pullBillQrCodeData(useSpinner);
            case 5:
              result = _context6.sent;
              _context6.next = 11;
              break;
            case 8:
              _context6.next = 10;
              return _this9.pullOrderQrCodeData(useSpinner);
            case 10:
              result = _context6.sent;
            case 11:
              if (result) {
                _this9.qrCodeModal.qrCodeUrl = result;
                _this9.qrCodeModal.regetShow = false;
                _this9.qrCodeModal.overtime = 60;
                _this9.qrCodeModal.show = true;
                _this9.createRegetQrCodeTimeout();
              }
              return _context6.abrupt("return", result);
            case 13:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    // 拉取支付方式
    pullPayMode: function pullPayMode() {
      return this.$getHttpClient().get("/pjyy-deepexi-pay-center/api/v1/channel/validList", {
        params: {
          payType: "ONLINE"
        }
      }).then(function (responses) {
        var data = responses.data;
        if (data.code === "200") {
          return data.data;
        }
        return;
      });
    },
    // 初始化支付方式
    initPayMode: function initPayMode() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var result;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this10.pullPayMode();
            case 2:
              result = _context7.sent;
              if (result) {
                _this10.payment.mode = result[0].code;
                _this10.payment.list = result;
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    // 刷新二维码
    regetQrCode: function regetQrCode() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this11.initQrCodeInfo(false);
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    // 去支付
    toPayModal: function toPayModal() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this12.initQrCodeInfo();
            case 2:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    }
  }
};